/**
 * ⛏️ TIER 2 BUILDINGS - Stone Age
 * 
 * Unlocked by: Mining technology
 * Cost multiplier: 2.5x | Prod multiplier: 1.6x
 * Costs: 125-250 | Production: 0.65-1.0/s
 * Target ROI: ~90 seconds
 */

export const TIER_02_BUILDINGS = {
  quarry: {
    id: 'quarry',
    name: 'Stone Quarry',
    icon: '⛏️',
    tier: 2,
    description: 'Mines stone from the earth',
    flavor: 'Solid foundations for a solid future.',
    baseCost: { wood: 125, stone: 25 },
    baseProduction: { stone: 0.65 },
    unlockCondition: { tech: 'mining' },
  },

  stonePit: {
    id: 'stonePit',
    name: 'Stone Pit',
    icon: '🕳️',
    tier: 2,
    description: 'Deep stone extraction',
    flavor: 'Dig deep, build high.',
    baseCost: { wood: 175, stone: 75 },
    baseProduction: { stone: 1.0 },
    unlockCondition: { tech: 'mining' },
  },

  prospectorCamp: {
    id: 'prospectorCamp',
    name: 'Prospector Camp',
    icon: '🏴',
    tier: 2,
    description: 'Scouts dig for stone and ore deposits',
    flavor: 'Where there is stone, iron often hides beneath.',
    baseCost: { wood: 150, stone: 50 },
    baseProduction: { stone: 0.4, iron: 0.15 },
    unlockCondition: { tech: 'mining' },
  },

  deepMine: {
    id: 'deepMine',
    name: 'Deep Mine',
    icon: '🏔️',
    tier: 2,
    description: 'Digs even deeper for rare ores',
    flavor: 'Fortune favors the deep.',
    baseCost: { wood: 200, stone: 100 },
    baseProduction: { iron: 0.2 },
    unlockCondition: { tech: 'mining' },
  },
};

export default TIER_02_BUILDINGS;